import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const ContactHero = () => {
  const b = useBilingual();
  return (
    <section className="relative pt-32 pb-16 bg-stone-900 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src={asset("/editorial/contact-hero-bg.jpg")}
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-stone-900/95 to-stone-900/80" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-amber-700/30" />

      <div className="relative z-10 max-w-screen-xl mx-auto px-6">
        <div className="flex items-center gap-3 mb-5">
          <span className="block h-px w-8 bg-amber-600" />
          <p className="text-amber-500 text-xs font-semibold tracking-widest uppercase">
            {b("Get in Touch", "聯絡我們")}
          </p>
        </div>
        <h1
          className="text-3xl md:text-5xl font-bold text-white mb-5 max-w-2xl leading-tight"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {b(
            "Speak with the Forwaro export team",
            "與 Forwaro 外銷團隊直接對話",
          )}
        </h1>
        <p className="text-stone-400 text-base max-w-xl leading-relaxed">
          {b(
            "Our export desk in Dongguan handles every inquiry personally — no call-centre middle layer.",
            "位於東莞的外銷窗口親自處理每一筆詢問，無客服中介轉接。",
          )}
          <br />
          {b(
            "Reach out by email, phone, or WhatsApp and we'll respond within two business days.",
            "可透過電子郵件、電話或 WhatsApp 聯繫，我們會在兩個工作日內回覆。",
          )}
        </p>
      </div>
    </section>
  );
};

export default ContactHero;
